import { render } from "./AnnouncementsEdit.vue?vue&type=template&id=ada8d8aa"
import script from "./AnnouncementsEdit.vue?vue&type=script&lang=js"
export * from "./AnnouncementsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__